import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../../components/ui/avatar';
import { ChevronRight } from 'lucide-react';

export default function TreeNode({ node, onSelect }) {
  // Plain recursive function that returns raw JSX elements to avoid recursive custom component compilation errors in development mode
  const drawNode = (n) => {
    return (
      <div key={n.id} className="flex flex-col items-center animate-fade-in">
        <div
          onClick={() => onSelect(n.userRef || n)}
          className="bg-white border border-slate-200 rounded-xl p-3 shadow-sm hover:shadow-md cursor-pointer transition flex items-center gap-3 w-60 relative group border-t-4 border-t-blue-500"
        >
          <Avatar className="w-8 h-8 ring-2 ring-slate-100">
            <AvatarImage src={n.avatar} />
            <AvatarFallback className="bg-slate-100 text-slate-500">
              {n.name ? n.name.charAt(0) : 'U'}
            </AvatarFallback>
          </Avatar>
          <div className="min-w-0 flex-1">
            <p className="text-xs font-bold text-slate-800 truncate">{n.name}</p>
            <p className="text-[10px] text-slate-400 font-bold uppercase mt-0.5">{n.role}</p>
          </div>
          <ChevronRight className="w-3.5 h-3.5 text-slate-400 group-hover:translate-x-1 transition-transform" />
        </div>

        {n.children && n.children.length > 0 && (
          <div className="flex flex-col items-center mt-6 relative">
            {/* Vertical connecting line */}
            <div className="absolute -top-6 w-px h-6 bg-slate-200" />

            <div className="flex gap-6 relative">
              {/* Horizontal line for multiple children */}
              {n.children.length > 1 && (
                <div className="absolute top-0 left-12 right-12 h-px bg-slate-200" />
              )}

              {n.children.map(child => (
                <div key={child.id} className="relative pt-6 flex flex-col items-center">
                  {/* Vertical branch line */}
                  <div className="absolute top-0 w-px h-6 bg-slate-200" />
                  {drawNode(child)}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  return drawNode(node);
}
